import React from "react";
import PropTypes from "prop-types";
import {
  IconGitHub,
  // IconInstagram,
  IconLinkedin,
  IconLoader,
  IconLogo,
  IconExternal,
} from "../icons";

const Icon = ({ name }) => {
  switch (name) {
    case "GitHub":
      return <IconGitHub />;
    // case "Instagram":
    //   return <IconInstagram />;
    case "Linkedin":
      return <IconLinkedin />;
    case "Loader":
      return <IconLoader />;
    case "Logo":
      return <IconLogo />;
    default:
      return <IconExternal />;
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
